import { render, staticRenderFns } from "./staffFeeManageList.vue?vue&type=template&id=35d3c67c&scoped=true"
import script from "./staffFeeManageList.vue?vue&type=script&lang=js"
export * from "./staffFeeManageList.vue?vue&type=script&lang=js"
import style0 from "./staffFeeManageList.vue?vue&type=style&index=0&id=35d3c67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d3c67c",
  null
  
)

export default component.exports